import { ICurrentWorkoutSelectionRepository } from '../interfaces/ICurrentWorkoutSelectionRepository';

export class InMemoryCurrentWorkoutSelectionRepository implements ICurrentWorkoutSelectionRepository {
    private db = {};
    public async getActiveWorkoutSelectionForSelectionKey(workoutSelectionKey: string): Promise<any> {
        return this.db[workoutSelectionKey];
    }

    public async getActiveWorkoutSelectionForSelectionKeyInTimezone(
      workoutSelectionKey: string,
      timezone: string,
    ): Promise<number> {
        return this.db[workoutSelectionKey];
    }

    public async getAll(): Promise<any> {
        return this.db;
    }

    public async setActiveWorkoutSelectionFor(workoutSelectionKey: string, workoutNumber: number) {
        this.db[workoutSelectionKey] = workoutNumber;
    }

    public async createDefaultDoc(defaultCounts: any) {
        this.db = defaultCounts;
    }

    public copyMasterDocumentToTimezone(timezone: string): Promise<void> {
        return Promise.resolve();
    }
}
